import styled from "styled-components"

const SimpleInput = styled.input`
  width: ${({ width = "100%" }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  height: ${({ height = "50px" }) => height};
  padding: 0;
  box-sizing: border-box;
  border: ${({ noBorder, error, disabled, theme: { colors } }) =>
    noBorder ? "none" : `1px solid ${error && !disabled ? colors.error : colors.ui.inputBorder}`};
  border-radius: 8px;
  outline: none;

  font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  font-size: 1rem;
  text-indent: ${({ textIndent = "15px" }) => textIndent};

  color: ${({ disabled, theme }) => disabled ? theme.colors.text.disabledInput : theme.colors.text.input};
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.white};
  caret-color: ${({ theme }) => theme.colors.primary};
  appearance: none;
  -webkit-tap-highlight-color: ${({ theme }) => theme.colors.black};
  
  transition: all 500ms ease;

  &:focus {
    border-color: ${({ theme, error }) => !error && theme.colors.primary};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.inputPlaceholder};
  }
`
export default SimpleInput
